import { Point } from 'shared/chart/core/types';

export function mapBurstDataToPoints(data: number[], rate: number): Point[] {
    const sampleCount = data.length;

    return data.map((amplitude, index) => ({
        y: amplitude,
        x: (index * (rate / 2)) / sampleCount,
    }));
}

/**
 * Determines the direction a numeric value is relative to a range.
 *
 * @example
 *  | value | range   | result |
 *  |------:|---------|-------:|
 *  |   250 | 0..10   |  right |
 *  |  -250 | 0..10   |   left |
 *  |  -250 | 100..0  |   left |
 *  |     4 | 0..-100 |   left |
 *  |  -104 | 0..-100 |  right |
 *  |  --50 | 0..-100 | within |
 */
export function directionFromRange(
    value: number,
    rangeStart: number,
    rangeEnd: number
): 'right' | 'left' | 'within' {
    if (rangeEnd > rangeStart) {
        // the range is ascending  (e.g. -10..100)
        if (value < rangeStart) {
            return 'left';
        }
        if (value > rangeEnd) {
            return 'right';
        }
    } else {
        // the range is descending (e.g. 100..-10)
        if (value > rangeStart) {
            return 'left';
        }
        if (value < rangeEnd) {
            return 'right';
        }
    }
    return 'within';
}
